import { Component, OnInit } from '@angular/core';
import {LoginService} from '../login.service';

@Component({
  selector: 'app-leftnav',
  templateUrl: './leftnav.component.html',
  styleUrls: ['./leftnav.component.css']
})
export class LeftnavComponent implements OnInit {
  show:Boolean = true;
  words:any='';
  valid:Boolean = false;
  constructor(public loginService:LoginService) { }

  ngOnInit() {
    // setTimeout(()=>{
    //   this.load();
    // },1000)
  }
  keyPress(event){
    if(this.words.replace(/ +/g, "").length >= 3){
      this.show = false;
    }
    else{
      this.show = true;
    }
  }
  load(){
    this.loginService.staticData.get('SurveyLinks').forEach((element)=>{
      if((new Date(element.activeBeginDt)<= new Date()) && (new Date(element.activeEndDt)>= new Date()) && (element.activeSW == 'Y')){
        this.valid = true;
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/leftnav/leftnav.component.ts